export default __webpack_public_path__ + "static/media/pleca_constancia.6fd5029b.png";